module.exports = __webpack_public_path__ + "img/logo4.74e7279c.png";